import { render, staticRenderFns } from "./PollsDetail.vue?vue&type=template&id=b7e62d8a"
import script from "./PollsDetail.vue?vue&type=script&lang=ts"
export * from "./PollsDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports